import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import "./MarkdownPage.css";

export default function MarkdownPage({ source, title }) {
  const [content, setContent] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setContent("");
    setError(null);

    fetch(source)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load (${res.status})`);
        return res.text();
      })
      .then((text) => {
        if (!cancelled) setContent(text);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      });

    return () => {
      cancelled = true;
    };
  }, [source]);

  useEffect(() => {
    if (title) {
      const previous = document.title;
      document.title = `${title} — Stress Ball`;
      return () => {
        document.title = previous;
      };
    }
  }, [title]);

  return (
    <div className="markdownPage-container">
      <article className="markdownPage-content">
        {error && (
          <div className="markdownPage-error">
            Couldn't load this document: {error}
          </div>
        )}
        {!error && !content && (
          <div className="markdownPage-loading">Loading…</div>
        )}
        {content && (
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        )}
      </article>
    </div>
  );
}
